import { Observable } from "rxjs";

export abstract class AbStepArea {
  abstract qtdFinalizadas: number;
  abstract getResultadoCompleted(): number;
  abstract observableCompleted(): Observable<boolean>;
  abstract setResultadoCompleted(): Observable<any>;
  abstract setVoltarResultadoCompleted(): Observable<any>;
  abstract reiniciarContagem();
  abstract terminarContagem();
}